import { Alert, Button, Card, Checkbox, Col, Form, Input, Row, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { uuidV4 } from 'src/util/Util'
import { SspBean } from '../../../api/api'
import { env } from '../../../env'
import { FormDataType, formDataLoader } from '../../../util/FormDataLoader'
import './style.css'

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea
const bidRequestJson = require('./bidRequest.json')

const formInfoItems: FormDataType[] = [
    FormDataType.Countries,
    FormDataType.Languages,
    FormDataType.Platforms,
    FormDataType.Ssps,
    FormDataType.IabCategories,
]

const TestRequest = () => {

    const [info, setInfo] = useState({
        ssps: []
    })

    const [ssp, setSsp] = useState<string>()
    const [requestBody, setRequestBody] = useState<string>()
    const [loading, setLoading] = useState<boolean>(false)

    const [responseStatus, setResponseStatus] = useState<string | undefined>(undefined)
    const [responseBody, setResponseBody] = useState<string>('')
    const [trace, setTrace] = useState<boolean>(false)
    const [adCode, setAdCode] = useState<string | undefined>(undefined)
    const [error, setError] = useState(undefined)

    const bidRequest = JSON.stringify(bidRequestJson, null, 4) as string

    const loadData = async () => {
        try {
            const formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
            setSsp(formInfo.ssps && formInfo.ssps[0].endpoint)
            setRequestBody(bidRequest)
        } catch (e) {
            onRejected(e)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = () => {
        try {
            setLoading(true)

            const requestURL = `${env.bidder}/${ssp}${trace ? '?trace=true' : ''}`

            let timeout = 0
            if (responseStatus) {
                setResponseStatus(undefined)
                setAdCode(undefined)
                setResponseBody('')
                timeout = 300
            }

            const body = requestBody && requestBody
                .replace('{REQUEST_ID}', uuidV4())
                .replace('{IMP_ID}', uuidV4())

            const options: RequestInit = {
                method: 'POST',
                body: body,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                }
            }

            setTimeout(() => {
                fetch(requestURL, options)
                    .then(response => {
                        if (!response.ok || response.status != 200) {
                            throw response
                        }
                        setResponseStatus(JSON.stringify(response.status))
                        return response.json()
                    })
                    .then((response: any) => {
                        const bid: any = response
                            && response.seatbid
                            && response.seatbid[0].bid
                            && response.seatbid[0].bid[0]

                        let adm = bid && bid.adm
                        if (!adm) {
                            adm = ''
                        }

                        setResponseBody(JSON.stringify(response, null, 4))
                        setAdCode(adm)
                        setLoading(false)

                        if (bid) {
                            const winUrl = (bid.nurl as string).replace('${AUCTION_PRICE}', bid.price)
                            fetch(winUrl)
                                .then(r => {
                                    if (r.ok) {
                                        const imprUrl = winUrl.replace('win', 'impr')
                                        fetch(imprUrl)
                                    }
                                })
                                .catch(e => console.log('Failed to fetch event. winUrl: ' + winUrl + ' error: ' + e))
                        }
                    })
                    .catch(err => {
                        setLoading(false)
                        if (err && err.status) {
                            setResponseStatus(err.status + ' ' + err.statusText)
                        } else {
                            setResponseStatus(err.message)
                        }
                    })

            }, timeout)
        } catch (e) {
            onRejected(e)
        }
    }

    const onRejected = e => {
        setError(e.error)
    }

    return <div>
        {error && <Alert message={error} type="error" />}
        <Row>
            <Col span={10}>
                <Form
                    style={{
                        maxWidth: '1000px'
                    }}
                    onFinish={handleSubmit}
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 19 }}
                >
                    <FormItem label="URL" >
                        <Input value={env.bidder + '/' + ssp} />
                    </FormItem>
                    <FormItem label="SSP">
                        <Select value={ssp} onChange={setSsp}>
                            {info.ssps.map((item: SspBean) => <Option key={item.id} value={item.endpoint}>{item.name}</Option>)}
                        </Select>
                    </FormItem>
                    <FormItem label="Trace" initialValue={false}>
                        <Checkbox onChange={e => setTrace(e.target.checked)} />
                    </FormItem>
                    <FormItem label="Request Body">
                        <TextArea value={requestBody} rows={25} onChange={e => setRequestBody(e.target.value)} />
                    </FormItem>
                    <FormItem
                        wrapperCol={{
                            offset: 11, span: 6
                        }}>
                        <Button
                            type="primary"
                            ghost
                            style={{
                                width: '100%',
                                margin: '0 2%'
                            }} htmlType="submit">Send</Button>
                    </FormItem>
                </Form>
            </Col>
            <Col span={14}>
                <Card style={{
                    maxWidth: '800px',
                    marginLeft: '10px'
                }} title="Server Response" loading={loading}>
                    {responseStatus == '200' ? <pre>{responseBody}</pre> : responseStatus}
                </Card>
                <br />
                <Card style={{
                    maxWidth: '800px',
                    marginLeft: '10px'
                }} title="AdCode View" loading={loading}>
                    {responseStatus == '200' ? <div dangerouslySetInnerHTML={{ __html: adCode ? adCode : '' }} /> : responseStatus}
                </Card>
            </Col>
        </Row>
    </div>
}

export default TestRequest


// WEBPACK FOOTER //
// ./src/component/app/request/TestRequest.tsx